import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import { PERIODO_TODO } from '../../commons/filters/periodos.js';
import { llavesEnVigilanciaHabilitada } from './solicitudEstado.js';

export const SOLICITUDES_FILTROS_STORAGE_KEY = 'SolicitudesGrid_filtros';

export const getSolicitudesFilterDefaults = (intl) => ({
	periodo: {
		id: PERIODO_TODO,
		label: intl.formatMessage({ id: 'Todo', defaultMessage: 'Todo' }),
	},
});

const ANCHO_MEDIO = { xs: 12, sm: 6, md: 3, lg: 3 };

// Mismas configs con las que el alta guarda la fecha de turno (SolicitudService::resolverFechaHoraTurno).
export const fechaTurnoHabilitada = () =>
	ConfigBusiness.get('mantenimientos.correctivo.fechaTurno.habilitado') === 'true' &&
	ConfigBusiness.get('mantenimientos.correctivo.gerenciadores.habilitado') === 'true' &&
	ConfigBusiness.get('tickets.motivoAsignacion.habilitado') !== 'true';

export const buildSolicitudesFilterFields = (intl) => [
	{
		name: 'entidad',
		type: 'text',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.entidad', defaultMessage: 'Entidad' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'estado',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.estado', defaultMessage: 'Estado' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'base',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.base', defaultMessage: 'Base' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'region',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.region', defaultMessage: 'Región' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'centroCostos',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.centro_costos', defaultMessage: 'Centro de costos' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'llavesEnVigilancia',
		type: 'multiselect',
		label: intl.formatMessage({ id: 'solicitudes.llaves_en_vigilancia', defaultMessage: 'Llaves en vigilancia' }),
		size: ANCHO_MEDIO,
		visible: llavesEnVigilanciaHabilitada(),
	},
	{
		name: 'periodo',
		type: 'periodo',
		startName: 'fechaDesde',
		endName: 'fechaHasta',
		label: intl.formatMessage({ id: 'solicitudesGrid.filtros.fecha_alta', defaultMessage: 'Fecha de alta' }),
		size: ANCHO_MEDIO,
	},
	{
		name: 'turno',
		type: 'periodo',
		startName: 'fechaTurnoDesde',
		endName: 'fechaTurnoHasta',
		// Los turnos pueden ser futuros: un solo extremo filtra sin tope o sin piso, y "Este año"
		// llega al 31/12 (VEC-4514).
		permiteExtremoVacio: true,
		esteAnioCompleto: true,
		label: intl.formatMessage({ id: 'Fecha_de_turno', defaultMessage: 'Fecha de turno' }),
		size: ANCHO_MEDIO,
		visible: fechaTurnoHabilitada(),
	},
];
